import {Dialog} from "primereact/dialog";
import React from "react";
import { Button } from "primereact/button";
import {ScheduledTaskDTO} from "../../../../api/model/airflow-task/ScheduledTaskDTO";

namespace TemplateUpdateDialog {
    export type Props = {
        taskCfg: ScheduledTaskDTO,
        onUpdate: () => void,
        visible: boolean,
        setVisible: (visible: boolean) => void,
    }
}

export default function TemplateUpdateDialog(props: TemplateUpdateDialog.Props ) {
    const templateInfo = props.taskCfg.templateInfo

    const footer = () => <div className="flex justify-content-between">
        <Button label="Update" className="p-button-success" onClick={() => props.onUpdate()} />
        <Button label="Cancel" className="p-button-secondary" onClick={() => props.setVisible(false)} />
    </div>

    return <Dialog header="Template update dialog"
                   visible={props.visible}
                   style={{width: 'min(650px, 50vw)'}}
                   footer={footer}
                   onHide={() => props.setVisible(false)}
    >
        <div className="p-fluid grid formgrid">
            <div className="p-field p-col-4">
                <h5>Template ID</h5>
                <span>{templateInfo.templateId}</span>
            </div>

            <div className="p-field p-col-4">
                <h5>Template Version</h5>
                <span>{templateInfo.templateVersion}</span>
            </div>

            <div className="p-field p-col-4">
                <h5>Template Type</h5>
                <span>{templateInfo.type}</span>
            </div>
        </div>
    </Dialog>
}